<script>

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
    name: 'checkbox-card',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
    },

    //--------------------------------------------------
    // component props
    //--------------------------------------------------
    props: {
        id: String,
        label: String,
        subtext: String,
        description: String,
        checked: Boolean,
        disabled: Boolean,
	},

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['change-data', 'disable-data'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            opened: null
        }
    },

    watch: {
        checked(value) {
            // console.log('watch checked', value)
            this.opened = value
        }
    },
    
    mounted() {
        // console.log('mounted', this.checked)
        this.opened = this.checked
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onCheckboxClick() {
            console.log('onCheckboxClick')
            this.opened = !this.opened
            if (this.id) {
                this.$emit('change-data', {id: this.id, opened: this.opened})
            }
            else {
                this.$emit('change-data', this.opened)
            }
        },
        onDisabledCheckboxClick() {
            console.log('onDisabledCheckboxClick')
            this.$emit('disable-data')
        },
    },
}
</script>

<template>
    <!-- component -->
    <div class="checkbox-card">
        <div v-if="!disabled" class="bg-white corner-round-sm u-square-padding" @click="onCheckboxClick">
            <div class="title">
                <span class="main-text main-color">{{ label }}</span>
                <span class="minor-text minor-color"> {{ subtext }}</span>
                <span class="pull-right">
                    <span v-if="opened" class="primary-color"><i class="iconfont iconfont-select"/></span>
                    <span v-else class="main-line-color"><i class="iconfont iconfont-select"/></span>
                </span>
            </div>
            <div v-if="description" class="description t-inner-margin">
                <span class="minor-text minor-color">{{ description }}</span>
            </div>
        </div>
        <div v-else class="bg-white corner-round-sm u-square-padding" @click="onDisabledCheckboxClick">
            <div class="title">
                <span class="main-text disable-color">{{ label }}</span>
                <span class="minor-text disable-color"> {{ subtext }}</span>
                <span class="pull-right">
                    <span class="disable-color"><i class="iconfont iconfont-select "/></span>
                </span>
            </div>
            <div v-if="description" class="description t-inner-margin">
                <span class="minor-text disable-color">{{ description }}</span>
            </div>
        </div>
    </div>
</template>